import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Prestations from "@/pages/Prestations";
import Realisations from "@/pages/Realisations";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/prestations" element={<Prestations />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<Legal type="mentions" />} />
          <Route path="/confidentialite" element={<Legal type="confidentialite" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
